import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucCircleMinus: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12ZM7.875 10.875C7.21875 10.875 6.75 11.3906 6.75 12C6.75 12.6562 7.21875 13.125 7.875 13.125H16.125C16.7344 13.125 17.25 12.6562 17.25 12C17.25 11.3906 16.7344 10.875 16.125 10.875H7.875Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucCircleMinus
